import React, {Component} from "react";
import ReactDOM from 'react-dom';

import pixel from "../About/img/pole-pixel-villeurbanne-integral-service.jpg";
import styles from "./ContactFind.module.scss";

class ContactFind extends Component {

    render() {
        if (this.state && this.state.type && this.state.message) {
            var classString = 'alert alert-' + this.state.type;
            var status = <div id="status" className={classString} ref="status">
                           {this.state.message}
                         </div>;
        }

        return (
            <div>
        <section id="fh5co-contact" className={`row-bottom-padded-lg row-top-padded-lg ${styles.fh5coContact}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <h2 className="text-left">Nous contacter</h2>
                            <p>N'hésitez pas à nous contacter, nous vous répondrons dans les plus brefs délais !</p>
                        </div>
                        <div className="col-md-7">

                            {status}

                            <form action="" method="POST" className="animate-box" onSubmit={this.handleSubmit.bind(this)}>
                                <input type="text" className="form-control" placeholder="Votre nom" id="name" name="name" ref="name" />
                                <input type="email" className="form-control" placeholder="Votre email" id="email" name="email" ref="email" />
                                <textarea className="form-control" placeholder="Votre message" id="message" name="message" ref="message" rows="6" />
                                <input type="submit" value="Envoyer" className="btn btn-primary" />
                            </form>
                        </div>
                    </div>
                </div>
        </section>
        <section className={`row-bottom-padded-lg row-top-padded-lg ${styles.contactdetails}`}>
            <div className="container container-find-us">
                <h2 className="text-left">Nous trouver</h2>
                <div className="row find-us">
                    <div className="col-md-6">
                    <img src={pixel} alt="Photo du pôle Pixel" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                    <div className="adress-about" itemScope="" itemType="http://schema.org/Person">
                        <ul>
                            <li><i className="icon-phone"></i>&nbsp;<a href="tel:+33437697209" title="Appeler Integral Service"><span itemProp="telephone">33 (0)4 37 69 72 09</span></a></li>
                            <li><i className="icon-fax"></i>&nbsp;<span itemProp="faxNumber">33 (0)4 72 33 88 45</span></li>
                            <li><i className="icon-envelope"></i>&nbsp;<span itemProp="email">info(at)integral-service.fr</span></li>
                            <li className="details"><i className="icon-location2"></i>&nbsp;<span itemProp="name">INTEGRAL SERVICE</span><br /><div><span itemProp="streetAddress">36 rue Emile Decorps<br /> Batiment 23<br /></span>  <span itemProp="postalCode">69100</span> <span itemProp="addressLocality">VILLEURBANNE, France</span></div></li>
                        </ul>
                    </div>
                    </div>
                </div>   
                <div className="row find-us-map"> 
                    <div className="row">
                        <div className="col-md-12">
                            <div className="embed-responsive  embed-responsive-16by9">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.696704183106!2d4.896692015780843!3d45.75722602186329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4c1b3c098cb3d%3A0xd9e88d1ca910efc4!2sIntegral+Service!5e0!3m2!1sen!2sfr!4v1503069836873" frameBorder="0" allowFullScreen  className="embed-responsive-item"></iframe>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        </div>
        );
    }

    handleSubmit(e){
      e.preventDefault();
      this.setState({ type: 'info', message: 'Envoi en cours...' }, this.sendFormData);
    }

    getFormData() {
        return {
            name:        this.refs.name.value,
            email:       this.refs.email.value,
            description: this.refs.message.value
        };
    }

    validateForm(formData) {
        if (
                formData.name        === "" || typeof formData.name        === "undefined"
            ||  formData.email       === "" || typeof formData.email       === "undefined"
            ||  formData.description === "" || typeof formData.description === "undefined"
        ) {
            return false;
        }

        return true;
    }

    sendFormData() {
        if (typeof window !== "undefined") {
            var _this = this;

            // Fetch form values.
            var formData = this.getFormData();

            if (!this.validateForm(formData)) {
                _this.setState({ type: 'danger', message: 'Veuillez renseigner tous les champs du formulaire' });
                return false;
            }

            // Send the form data.
            var xmlhttp = new XMLHttpRequest();

            xmlhttp.onreadystatechange = function() {
              if (xmlhttp.readyState === 4) {

                var response = null;

                try {
                  var response = JSON.parse(xmlhttp.responseText);
                } catch (e) {}

                if (xmlhttp.status === 200 && response !== null && response.status === 'OK') {
                  _this.setState({ type: 'success', message: 'Merci ! Nous vous répondrons au plus vite !' });
                  _this.refs.name.value    = "";
                  _this.refs.email.value   = "";
                  _this.refs.message.value = "";
                }
                else {
                  _this.setState({ type: 'danger', message: 'Désolé, une erreur est survenue. Merci de nous contacter par email : info@integral-service.fr' });
                }
              }
            };
            xmlhttp.open('POST', '/php/send.php', true);
            xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xmlhttp.send(this.requestBuildQueryString(formData));
        }
    }

    requestBuildQueryString(params){    
        var queryString = [];
        for(var property in params)
            if (params.hasOwnProperty(property)) {
            queryString.push(encodeURIComponent(property) + '=' + encodeURIComponent(params[property]));
            }
    
        return queryString.join('&');
    
    }
}

export default ContactFind;



// WEBPACK FOOTER //
// ./src/components/Contact/ContactFind.jsx